import { Injectable } from "@angular/core";
import { formatDate } from '@angular/common';


@Injectable({ providedIn: 'root' })
export class GlobasConst {
    public get dateTimeFormat(): string {
        return 'MMM d, y, h:mm a';
    }
    public get dateFormat(): string {
        return 'MMM d, y';
    }

    public formatDateFromServer(dateString: string | undefined): string {
        if (!dateString) return '';
    
        // Extract the date part from the input string
        const dateParts = dateString.split(' ');
        if (dateParts.length < 4) return dateString; 
    
        const day = dateParts[0]; // e.g., '3'
        const month = dateParts[1]; // e.g., 'Jan'
        const year = dateParts[2]; // e.g., '2025'
    
        // Reformat to 'Jan 3, 2025'
        return `${month} ${parseInt(day, 10)}, ${year}`;
    }
    
    public get timeFormat(): string {
        return 'h:mm a';
    }

    public get moneyFormat(): any {
        return {
            currencyFormat: 'USD',
            currencyDisplay: 'symbol',
            currencyPrecision: '1.2-2',
        }
    }


    public formatDateForServer(dateString: string | undefined): string {
        if (!dateString) return '';
    
        // ✅ Expected input: "9 Mar 2025 6:05 PM EDT"
        const dateParts = dateString.split(' ');
    
        if (dateParts.length < 5) return dateString; // Ensure we have enough parts
    
        const [day, month, year, time, period] = dateParts;
    
        // ✅ Convert month name to number
        const monthNumber = ("Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" ").indexOf(month) + 1)
            .toString().padStart(2, "0");
    
        // ✅ Convert time to 24-hour format
        let [hours, minutes] = time.split(":").map(Number);
        if (period === "PM" && hours !== 12) hours += 12;
        if (period === "AM" && hours === 12) hours = 0;
        const time24 = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
    
        // ✅ Format to "YYYY-MM-DDTHH:mm:ss"
        return `${year}-${monthNumber}-${day.padStart(2, "0")}T${time24}:00.000`;
    }

    
    public formatToEST(dateInput: string | Date | undefined): string {
      if (!dateInput) return '';
    
      let date: Date;
    
      if (typeof dateInput === 'string') {
        const cleaned = dateInput.replace(/\.\d+/, '').replace(' Z', 'Z');
        
        const match = cleaned.match(/^(\d{1,2}) (\w{3}) (\d{4}) (\d{1,2}):(\d{2}):(\d{2}) (AM|PM)Z$/);
        if (!match) return '';
    
        const [, day, monthStr, year, hourStr, minStr, secStr, ampm] = match;
    
        const monthMap: Record<string, string> = {
          Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
          Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
        };
    
        const month = monthMap[monthStr];
        if (!month) return '';
    
        let hour = parseInt(hourStr, 10);
        if (ampm === 'PM' && hour !== 12) hour += 12;
        if (ampm === 'AM' && hour === 12) hour = 0;
    
        const iso = `${year}-${month}-${day.padStart(2, '0')}T${String(hour).padStart(2, '0')}:${minStr}:${secStr}Z`;
        date = new Date(iso);
      } else {
        date = dateInput;
      }
    
      if (isNaN(date.getTime())) return '';
    
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    
      const parts = formatter.formatToParts(date);
      const dateMap: any = {};
      parts.forEach((p) => {
        if (p.type !== 'literal') dateMap[p.type] = p.value;
      });
    
      const formatted = `${dateMap.month} ${dateMap.day}, ${dateMap.year}, ${dateMap.hour}:${dateMap.minute} ${dateMap.dayPeriod}`;
    
      const nyOffset = -new Date(date.toLocaleString('en-US', { timeZone: 'America/New_York' })).getTimezoneOffset();
      const isDST = nyOffset !== 300;
    
      return `${formatted} ${isDST ? 'EDT' : 'EST'}`;
    }
    
    
    


      formatDescriptionLine(line: string): string {
        if (!line) return '';
      
        const [firstWord, ...rest] = line.split(' ');
        const formattedFirst = firstWord.charAt(0).toUpperCase() + firstWord.slice(1).toLowerCase();
        const formattedRest = rest.join(' ').toLowerCase();
      
        return [formattedFirst, formattedRest].join(' ').trim();
      }


      formatDescriptionLineSpace(line: string): string {
        if (!line) return '';
        return line
        .split(' ')
        .map((word, index) =>
          word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : ''
        )
        .join(' ')
        .trim();
      }
      
      
}